import { FC, HTMLAttributes } from 'react';

import cn from 'classnames';

import { WebApp } from 'shared/utils';

import styles from './BottomPanel.module.scss';

interface IBottomPanelProps extends HTMLAttributes<HTMLDivElement> {}

export const BottomPanel: FC<IBottomPanelProps> = ({ className, children, ...props }) => {
	return (
		<div {...props} className={cn(className, styles.container)}>
			<div className={styles.panel} style={{ paddingBottom: WebApp?.safeAreaInset.bottom || 0 }}>
				{children}
			</div>
		</div>
	);
};
